import { render } from "./D3DonutChart.vue?vue&type=template&id=13409cfb"
import script from "./D3DonutChart.vue?vue&type=script&lang=js"
export * from "./D3DonutChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__